import { render, staticRenderFns } from "./BatchModal.vue?vue&type=template&id=4a924621&"
import script from "./BatchModal.vue?vue&type=script&lang=js&"
export * from "./BatchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports